<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner whole">
        <div class="modal bg-gray">
          <header class="header">
            <div class="inner">
              <h1 class="ttl">주소 설정</h1>
              <div class="right" style="padding-left: 5px">
                <button class="header-btn" @click="close()"><i class="ico-close-gray90"></i></button>
              </div>
            </div>
          </header>
          <!-- head fixed -->
          <div class="head">
            <div class="search-inner">
              <div class="label search">
                <input
                  type="text"
                  placeholder="도로명, 건물명, 지번으로 검색하기"
                  :disabled
                  ref="searchInput"
                  :value="addressSearchText"
                  @click="fnNaverSearchModal"
                />
              </div>
            </div>
          </div>

          <empty-items content="설정된 고정 주소 내역이 없습니다." v-if="isEmpty(addressList)" />
          <!-- // head fixed -->
          <div class="modal-con pd16" v-if="!isEmpty(addressList)">
            <ul class="card-list pd0">
              <!-- departed: 고인목록 | address-list: 검색목록 | onlineFuneral: 온라인장례식목록-->
              <li class="card address-list" v-for="address in addressList" @click="isSelect(address)">
                <div class="top flex-justi-con-space-between">
                  <p class="name">{{ getAddressCity(address.address) }}</p>
                  <span class="badge gray" v-if="address.isSelect">현재 고정 주소</span>
                </div>
                <div class="bottom">
                  <p class="address">{{ address.roadAddress }}</p>
                  <div class="btn-wrap">
                    <button class="btn border-gray xsmall widthFill" @click.prevent.stop="update(address)">수정</button>
                    <button
                      class="btn border-gray xsmall widthFill"
                      @click.prevent.stop="remove(address)"
                      v-if="!address.isSelect"
                    >
                      삭제
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import store from '@/store';
import { computed, onMounted, reactive, ref } from 'vue';
import EmptyItems from '@/components/common/layouts/EmptyItems.vue';
import { getAddressCity, isEmpty } from '@/common/utils/Util';
import { modalList, show, showDoneModal, showTextModal } from '@/common/utils/ModalState';

const addressList = computed(() => store.getters['business/getAddressList']);
const addressSearchText = computed(() => store.getters['business/getAddressSearchText']);
const emits = defineEmits(['close']);

const textRef = ref('');
const searchInput = ref();

onMounted(() => {
  store.commit('layout/setIsNav', false);
  store.commit('business/addressSearchText');
  fetch(true);
});

const textRemove = () => {
  textRef.value = '';
  store.commit('business/searchText', '');
};

const remove = data => {
  showDoneModal('주소를 삭제하시겠습니까?', '삭제', '취소', async () => {
    if (await store.dispatch('business/removeAddress', data.addressNo)) {
      fetch(true);
      showTextModal('주소를 삭제했습니다.', '확인');
    }
  });
};
const update = data => {
  show(modalList.BUSINESS_ADDRESS_DETAIL, { regData: data });
};
const fnNaverSearchModal = () => {
  const fnCallBack = data => {
    show(modalList.BUSINESS_ADDRESS_DETAIL, { regData: data });
  };
  show(modalList.NAVER_SEARCH, { fnCallBack, unClose: true, closeHeader: true, isDirectInput: false });
  setTimeout(() => {
    requestAnimationFrame(() => {
      searchInput.value?.blur();
    });
  }, 50);
};

const fetch = init => {
  const condition = store.getters['business/getAddressCondition'];
  if (init) {
    condition.page = 1;
    store.commit('business/addressCondition', condition);
  }
  store.dispatch('business/getAddressList');
};

const isSelect = async address => {
  if (await store.dispatch('business/selectAddress', address.addressNo)) {
    showTextModal('주소를 변경했습니다.', '확인');
    fetch(true);
    store.commit('business/initBusinessList');
    store.commit('business/coordinateChange', true);
    await store.dispatch('business/getBusinessList', { isKakao: false, isOneKM: true });
  }
};
const close = () => {
  setTimeout(() => {
    store.commit('layout/setIsNav', true);
    emits('close');
  }, 200);
};
</script>

<style scoped></style>
